import React from "react";
import {
  FormField,
  FormInput,
  FormRow,
  FormRow2,
  RemoveButton,
} from "../styles/ChoosePlan";
import LimitedRelationshipModel from "../data/models/limitedRelationship";
import InputMask from "react-input-mask";

interface DependentProps {
  index: number;
  dependent: {
    nome: string;
    telefone: string;
    cpf: string;
    email: string;
    relationship: string;
    documentoFrente?: File;
    documentoVerso?: File;
  };
  onRemove: (index: number) => void;
  onChange: (index: number, field: string, value: string | File) => void;
  relationships: LimitedRelationshipModel[];
}

const LimitedDependent: React.FC<DependentProps> = ({
  index,
  dependent,
  onRemove,
  onChange,
  relationships,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    onChange(index, name, value);
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    onChange(index, name, value);
  };

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: string
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      onChange(index, field, file);
    }
  };

  return (
    <>
      <FormField>
        <FormRow2>
          <h1>Dependente {index + 1}</h1>
          <RemoveButton onClick={() => onRemove(index)}>x</RemoveButton>
        </FormRow2>
        <FormInput
          type="text"
          name="nome"
          placeholder="Nome Completo:"
          value={dependent.nome}
          onChange={handleInputChange}
        />
      </FormField>

      <FormRow>
        <FormField>
          <InputMask
            mask="(99) 99999-9999"
            value={dependent.telefone}
            onChange={handleInputChange}
          >
            {(inputProps: any) => (
              <FormInput
                {...inputProps}
                type="tel"
                name="telefone"
                placeholder="Telefone:"
              />
            )}
          </InputMask>
        </FormField>
        <FormField>
          <select
            name="relationship"
            value={dependent.relationship}
            onChange={handleSelectChange}
          >
            <option value="" disabled>
              Grau de Parentesco
            </option>
            {relationships.map((item) => (
              <option
                key={item.id_parentesco ?? ""}
                value={item.id_parentesco ?? ""}
              >
                {item.parentesco}
              </option>
            ))}
          </select>
        </FormField>
      </FormRow>

      <FormRow>
        <FormField>
          <InputMask
            mask="99999999999"
            value={dependent.cpf}
            onChange={handleInputChange}
          >
            {(inputProps: any) => (
              <FormInput
                {...inputProps}
                placeholder="CPF (Somente Números)"
                type="text"
                name="cpf"
              />
            )}
          </InputMask>
        </FormField>
        <FormField>
          <FormInput
            type="email"
            name="email"
            placeholder="E-mail:"
            value={dependent.email}
            onChange={handleInputChange}
          />
        </FormField>
      </FormRow>

      <FormRow>
        <FormField>
          <label>Documento (Frente):</label>
          <FormInput
            type="file"
            name="documentoFrente"
            accept="image/*,application/pdf"
            onChange={(e) => handleFileChange(e, "documentoFrente")}
          />
        </FormField>
        <FormField>
          <label>Documento (Verso):</label>
          <FormInput
            type="file"
            name="documentoVerso"
            accept="image/*,application/pdf"
            onChange={(e) => handleFileChange(e, "documentoVerso")}
          />
        </FormField>
      </FormRow>
    </>
  );
};

export default LimitedDependent;
